import { Box, styled } from "@mui/material";

export const Label = styled(Box)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  flexGrow: 1,
  width: "100%",
}));
